import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'cj-typeahead',
  templateUrl: './cj-typeahead.component.html',
  styleUrls: ['./cj-typeahead.component.scss'],
})
export class CJTypeahead implements OnInit {
  @Input() key = '';
  @Input() value = '';
  @Input() label = '';
  @Input() required = false;
  @Input() options = [];
  @Input() disabled = false;
  @Input() fullWidth = false;
  @Input() withClear = false;
  @Input() placeholder = '';
  @Input() icon = 'search';
  @Input() clearOnSelect = false;
  @Input() iconPlacement: 'prefix' | 'suffix' | '' = 'prefix';
  @Input() withEmptyOption = false;
  @Output() selectChanged = new EventEmitter<any>();
  @Output() clear = new EventEmitter<any>();
  @Output() enter = new EventEmitter<string>();
  @ViewChild('datalist') datalist!: ElementRef<HTMLDataListElement>;
  @ViewChild('input') input!: ElementRef<HTMLInputElement>;
  @ViewChild('overlay') overlay!: ElementRef<HTMLDivElement>;

  currentFocus = -1;
  htmlOptions: HTMLOptionElement[] = [];
  filteredOptions = [];
  offset = 20;
  math = Math;

  constructor() {}

  ngOnInit(): void {
    this.filteredOptions = this.options;
  }

  onBlur() {
    this.datalist.nativeElement.style.display = 'none';
    this.overlay.nativeElement.style.display = 'none';
    document.documentElement.classList.remove('menu-open')
    this.currentFocus = -1;
  }

  onInput(value: string) {
    this.datalist.nativeElement.style.display = 'block';
    this.overlay.nativeElement.style.display = 'block';
    document.documentElement.classList.add('menu-open')
    const inputRect = this.input.nativeElement.getBoundingClientRect();
    this.datalist.nativeElement.style.top =
      Math.ceil(inputRect.y) + Math.ceil(inputRect.height) + 'px';
    this.datalist.nativeElement.style.left = Math.ceil(inputRect.x) + 'px';
    this.filteredOptions = this.options.filter((option) => {
      const name = this.key ? option[this.key] : option;
      return name.toLowerCase().includes(value.toLowerCase());
    });

    this.currentFocus = 0;
  }

  onKeydown(event: KeyboardEvent) {
    switch (event.code) {
      case 'ArrowDown':
        this.currentFocus++;
        if (
          this.currentFocus >= this.filteredOptions.slice(0, this.offset).length
        ) {
          this.currentFocus = 0;
        }
        this.datalist.nativeElement.scrollTop =
          (this.currentFocus + 1) * 28 - 240;
        break;
      case 'ArrowUp':
        this.currentFocus--;
        if (
          this.datalist.nativeElement.scrollTop >
          (this.currentFocus + 1) * 28
        ) {
          this.datalist.nativeElement.scrollTop -= 28;
        }

        if (this.currentFocus < 0) {
          this.currentFocus =
            this.filteredOptions.slice(0, this.offset).length - 1;
          this.datalist.nativeElement.scrollTop =
            (this.currentFocus + 1) * 28 - 240;
        }

        break;
      case 'Enter':
        event.preventDefault();

        if (this.currentFocus > -1) {
          this.onSelect(this.filteredOptions[this.currentFocus]);
        } else {
          this.enter.emit(this.input.nativeElement.value);
        }
        break;
    }
  }

  onSelect(option) {
    this.datalist.nativeElement.style.display = 'none';
    this.overlay.nativeElement.style.display = 'none';
    document.documentElement.classList.remove('menu-open')

    if (this.clearOnSelect) {
      this.value = '';
      this.input.nativeElement.value = '';
      this.currentFocus = -1;
    } else {
      this.value = this.key && option ? option[this.key] : option;
      this.input.nativeElement.value =
        this.key && option ? option[this.key] : option;
    }
    this.selectChanged.emit(option);
  }

  onClear() {
    setTimeout(() => {
      this.value = '';
      this.input.nativeElement.value = '';
      this.currentFocus = -1;
      this.onInput('');
      this.clear.emit();
      this.input.nativeElement.focus();
    }, 1);
  }

  loadMore(event) {
    this.offset += 10;
    event.stopPropagation();
    this.datalist.nativeElement.style.display = 'block';
    this.overlay.nativeElement.style.display = 'block';
    document.documentElement.classList.add('menu-open')
  }

  trackBy(index: number, item: any) {
    return item.Id;
  }
}
